import dayjs from 'dayjs';

/**
 * 格式化时间
 * @param time - 时间戳
 * @param template - 时间格式
 * @returns 格式化后的时间
 */
export const formatTableTime = (time, template) => {
  if (!time) return '';
  const _time = time < 10000000000 ? time * 1000 : time;
  const date = dayjs(_time);
  if (!date.isValid()) return '';
  return date.format(template || 'h:mm:ss A');
};
